import { instance } from '@/services/avik-api-gateway'
import { v4 as uuidv4 } from 'uuid'

export interface TrackCount {
  from: string
  to: string
  track_count: number
  uuid?: string
}

export const getTrackCount = (): Promise<TrackCount[]> =>
  instance
    .get<{ place_from: string; place_to: string; track_count: number }[]>(
      `/graph/track-count`
    )
    .then((x) =>
      x.data.map((x) => ({
        from: x.place_from,
        to: x.place_to,
        track_count: x.track_count,
        uuid: uuidv4(),
      }))
    )
